import React, { Component } from 'react';
import { DataView } from 'primereact/dataview';
import { Notify } from "@shared/ui-native/Notify";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import './FileInfoDialog.scss';
import { Button } from "@shared/ui-react/Button";
import './OrthoInfoDialog.scss';
import { ProgressBar } from "primereact/progressbar";
import { InputText } from 'primereact/inputtext';
import { Ajax2 } from '@shared/Ajax';


interface MapDetailsResponse {
    XYZ: string;
    WMTS: string;
    state: number;
}

interface MapDetailsProps {
    project_uuid: string;
    file_uuid: string;
}

async function MapDetails(project_uuid: string, file_uuid: string): Promise<MapDetailsResponse | null> {
    // This function renders a window, which allows to view processing status of orthophotos
    try {
        const domain = kuura.AwsApiGatewayDomain();
        const path = 'reality-capture/raster/map-details';
        const url = new URL(path, domain).toString();
        const params = new URLSearchParams({
            project_uuid: project_uuid,
            file_uuid: file_uuid
        });
        const fetchUrl = `${url}?${params.toString()}`;
        return await Ajax2({url: fetchUrl, useToken: true, method: "GET", contentType: 'json'});
    }
    catch (err) {
        console.error(err);
        console.log(kuura.AwsApiGatewayDomain());
        return null;
    }
}

interface RenderComponentState {
    mapDetails: MapDetailsResponse | null;
}

class MapURL extends Component<MapDetailsProps, RenderComponentState> {
    intervalID: NodeJS.Timeout | null = null;

    constructor(props: MapDetailsProps) {
        super(props);
        this.state = {
            mapDetails: null
        };
    }

    async componentDidMount() {
        await this.fetchMapDetails();
        this.intervalID = setInterval(this.fetchMapDetails, 3000); // Fetch map details every 3 seconds
    }

    componentWillUnmount() {
        if (this.intervalID) {
            clearInterval(this.intervalID);
            this.intervalID = null;
        }
    }

    fetchMapDetails = async () => {
        try {
            const mapDetails = await MapDetails(this.props.project_uuid, this.props.file_uuid);
            this.setState({ mapDetails });
        } catch (err) {
            console.error(err);
        }
    }


    render() {
        try {
            const { mapDetails } = this.state;
            if (mapDetails === null) {
                return null;
            }

            const processingClass = mapDetails.state < 100 ? 'faded' : '';
            const processingClassText = mapDetails.state < 100 ? 'faded-text' : '';

            return (
                    <div className="flex-column gap-half">
                        <div className="card of-a" id="custom-container">
                            <DataView
                                value={[
                                    {
                                        label: "XYZ",
                                        value: mapDetails.XYZ
                                    },
                                    {
                                        label: "WMTS",
                                        value: mapDetails.WMTS
                                    }
                                ]}
                                layout="list"
                                itemTemplate={(item) => (
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                        <div style={{ width: 60 }}>{item.label}</div>
                                        <InputText
                                            className={`file-info-ortho-link ${processingClassText}`}
                                            value={item.value}
                                            readOnly
                                            style={{
                                                marginRight: 10,
                                                width: 350,
                                                height: 20,
                                                fontSize: 9
                                            }}
                                        />
                                        <CopyToClipboard text={item.value} onCopy={() => Notify.success('Copied')}>
                                            <Button className={`ik-button-small ${processingClass}`}>{__('js_map.copy_to_clipboard')}</Button>
                                        </CopyToClipboard>
                                    </div>
                                )}
                            />
                            {mapDetails.state < 0 &&
                                <div className="error-container">
                                    <div className="error-text">{__('js_files.msg.notifications.server_error')}!</div>
                                </div>
                            }
                            {(0 <= mapDetails.state && mapDetails.state < 100) &&
                                <div className="progress-container">
                                    <ProgressBar color="#4797CC" mode="indeterminate" className="progress-bar"/>
                                    <div className="progress-text">{__('js_files.processing')}</div>
                                    <ProgressBar color="#4797CC" mode="indeterminate" className="progress-bar"/>
                                </div>
                            }
                        </div>
                    </div>
                    );
        } catch (error) {
            console.log(error);
            return null;
        }
    }
}


export default MapURL;
